import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Overview from "./Overview/Overview";
import Summary from "./Summary/Summary";
import ProfitAnalytics from "./Analytics/ProfitAnalytics";
import RentOverview from "./RentOverview/RentOverview";
import PurchasePaymentProjection from "./PurchasePaymentProjection";
import {useEffect, useState} from "react";
import LoaderService from "../../RetroAssets.System/LoaderService";
import apiClient from "../../services/axios";
import {alert} from "devextreme/ui/dialog";
import ROIProjections from "./ROIProjections";

// Monthly Rent Overview is hidden, not retired. docs/RENT-CHART-AUDIT-01.md
// verdict B: the chart plots whole-contract totals against an axis labelled
// monthly rent (roughly 12x too high) and mixes currencies on one axis with no
// conversion. The tab stays out of the strip until the derivation is fixed.
// RentOverview.js, MonthlyRentOverview.txt, the controller action and the
// Api* method are all intact - flip this back to true to restore the tab.
const SHOW_MONTHLY_RENT_OVERVIEW_TAB = false;

function Dashboard() {
    const [accountCounts, setAccountCounts] = useState([]);
    const [propListing, setPropListing] = useState([]);
    const [summary, setSummary] = useState(false);
    const [profitAnalytics, setProfitAnalytics] = useState(false);
    const [rentOverview, setRentOverview] = useState(false);
    const [purchaseProjection, setPurchaseProjection] = useState(false)
    const [roiProjections, setRoiProjections] = useState(false)

    useEffect(() => {
        LoaderService.setData(true)
        apiClient
            .get('/Dashboard/GetAccountsAndPropertiesForDashboard')
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    setAccountCounts(data[0]['Accounts'])
                    setPropListing(data[1]['PropertyListing'])

                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }, []);

    const tabsSelectionChanged = e => {
        if (e.target.textContent === "Profit Analytics") {
            setProfitAnalytics(true)
            return
        } else if (e.target.textContent === "Payment Plan") {
            setPurchaseProjection(true)
            return;
        } else if (e.target.textContent === "summary") {
            setSummary(true)
        } else if (e.target.textContent === 'Monthly Rent Overview') {
            setRentOverview(true)
        } else if (e.target.textContent === 'ROI Projections') {
            setRoiProjections(true)
            return
        }
        setPurchaseProjection(false)
        setProfitAnalytics(false)
    }

    return (
        <>
            <Tabs defaultActiveKey="overview" className="fs-5 nav-tab px-2" onClick={tabsSelectionChanged}>
                <Tab eventKey="overview" title="overview">
                    <Overview accounts={accountCounts} propListing={propListing}/>
                </Tab>
                <Tab eventKey="summary" title="summary">
                    <Summary accounts={accountCounts} propListing={propListing}
                             loaded={summary}/>
                </Tab>
                <Tab eventKey="profitAnalytics" title="Profit Analytics">
                    <ProfitAnalytics accounts={accountCounts} propListing={propListing}
                                     loaded={profitAnalytics}/>
                </Tab>
                {SHOW_MONTHLY_RENT_OVERVIEW_TAB &&
                    <Tab eventKey="rentOverview" title="Monthly Rent Overview">
                        <RentOverview accounts={accountCounts} propListing={propListing}
                                      loaded={rentOverview}/>
                    </Tab>}
                <Tab eventKey="PurchasePaymentProjection" title="Payment Plan">
                    <PurchasePaymentProjection accounts={accountCounts} propListing={propListing}
                                               loaded={purchaseProjection}/>
                </Tab>
                <Tab eventKey="ROIProjections" title="ROI Projections">
                    <ROIProjections accounts={accountCounts} propListing={propListing}
                                    loaded={roiProjections}/>
                </Tab>
            </Tabs>
        </>
    );
}

export default Dashboard;